import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { resetPassword, clearRedux } from "../redux/slices/authSlice";
const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: email,
    token: token,
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { message, loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Đánh dấu đã render lần đầu
      dispatch(clearRedux());
      return; // Không làm gì
    }
    if (!loading) {
      if (message) {
        toast.success(message);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
      if (error) {
        toast.error(error);
      }
    }
  }, [loading]);

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!formData.newPassword.trim()) {
      newErrors.newPassword = "Mật khẩu không được để trống!";
    } else if (!passwordRegex.test(formData.newPassword)) {
      newErrors.newPassword =
        "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt!";
    }

    if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = "Mật khẩu nhập lại không khớp!";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      dispatch(resetPassword(formData));
    }
  };
  return (
    <>
      <div className="main-wrapper authentication-wrapper">
        <div className="container-fuild">
          <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-11 mx-auto">
                <div
                  className="p-4 text-center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="assets/img/logo-dark.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="card authentication-card">
                  <div className="card-header">
                    <div className="text-center">
                      <h5 className="mb-1">Đặt lại mật khẩu</h5>
                      <p>Nhập thông tin chi tiết để đặt lại mật khẩu</p>
                    </div>
                  </div>
                  <div className="card-body">
                    <form action="https://dreamstour.dreamstechnologies.com/html/login.html">
                      <div className="mb-3">
                        <label className="form-label">Mật khẩu</label>
                        <div className="input-icon">
                          <span className="input-icon-addon">
                            <i className="isax isax-lock"></i>
                          </span>
                          <input
                            type={showPassword ? "text" : "password"}
                            name="newPassword"
                            className="form-control form-control-lg"
                            placeholder="Nhập mật khẩu"
                            value={formData.newPassword}
                            onChange={handleChange}
                          />
                          <span
                            className="input-icon-addon toggle-password"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer" }} // Để icon có thể click
                          >
                            <i
                              className={
                                showPassword
                                  ? "isax isax-eye"
                                  : "isax isax-eye-slash"
                              }
                            ></i>
                          </span>
                        </div>
                        {errors.newPassword && (
                          <small className="text-danger">
                            {errors.newPassword}
                          </small>
                        )}
                      </div>
                      <div className="mb-4">
                        <label className="form-label">Nhập lại mật khẩu</label>
                        <div className="input-icon">
                          <span className="input-icon-addon">
                            <i className="isax isax-lock"></i>
                          </span>
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            className="form-control form-control-lg"
                            placeholder="Nhập lại mật khẩu"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                          />
                          <span
                            className="input-icon-addon toggle-password"
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            style={{ cursor: "pointer" }} // Để icon có thể click
                          >
                            <i
                              className={
                                showConfirmPassword
                                  ? "isax isax-eye"
                                  : "isax isax-eye-slash"
                              }
                            ></i>
                          </span>
                        </div>
                        {errors.confirmPassword && (
                          <small className="text-danger">
                            {errors.confirmPassword}
                          </small>
                        )}
                      </div>
                      <div className="mb-0">
                        <button
                          type="submit"
                          className="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
                          onClick={handleSubmit}
                          disabled={loading} // Vô hiệu hóa nút khi đang gửi yêu cầu
                        >
                          {loading ? (
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                          ) : (
                            <>
                              Đặt lại mật khẩu
                              <i className="isax isax-arrow-right-3 ms-2"></i>
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="coprright-footer">
          <p className="fs-14">
            Copyright &copy; 2025. All Rights Reserved,{" "}
            <a href="javascript:void(0);" className="text-primary fw-medium">
              DreamsTour
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default ChangePasswordPage;
